import script from "./AuthorizationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorizationPage.vue?vue&type=script&setup=true&lang=js"

import "./AuthorizationPage.vue?vue&type=style&index=0&id=8f5a16c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f5a16c0"]])

export default __exports__